import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useOrganizationClassificationUIContext } from "./OrganizationClassificationUIContext";
import { OrganizationClassificationFilter } from "./organization-classification-table/organization-classification-filter/OrganizationClassificationFilter";
import OrganizationClassificationCreate from "./organization-classification-create/OrganizationClassificationCreate";
import {
  fetchOrganizationClassifications,
  createOrganizationClassification,
  updateOrganizationClassification
} from "../../_redux/organization-classification/organizationClassificationAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import OrganizationClassificationTable from "./organization-classification-table/OrganizationClassificationTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { ConfirmationModal } from "../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { Collapse } from "react-bootstrap";
import { RoleChecker } from "../../../../RoleChecker";

export const OrganizationClassificationCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState({
    organizationClassification: false,
    confirmation: false
  });
  const initialValue = {
    is_all_organization: true,
    type: "INFO",
    expired_date: moment()
      .utc()
      .format("YYYY-MM-DDTHH:mm")
  };
  const [currentItem, setCurrentItem] = useState(initialValue);

  const [openFilter, setOpenFilter] = useState(false);

  // * OrganizationClassification UI Context
  const organizationClassificationUIContext = useOrganizationClassificationUIContext();
  const organizationClassificationUIProps = useMemo(() => {
    return {
      queryParams: organizationClassificationUIContext.queryParams,
      setQueryParams: organizationClassificationUIContext.setQueryParams,
      openEditOrganizationClassificationPage:
        organizationClassificationUIContext.openEditOrganizationClassificationPage,
      openOrganizationClassificationFilePage:
        organizationClassificationUIContext.openOrganizationClassificationFilePage
    };
  }, [organizationClassificationUIContext]);

  // * Getting curret state of organizationClassification list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminOrganizationClassification,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke OrganizationClassification Action
    dispatch(
      fetchOrganizationClassifications(
        organizationClassificationUIProps.queryParams
      )
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationClassificationUIProps.queryParams, dispatch]);

  const onSubmitOrganizationClassification = value => {
    if (!value.uuid) {
      dispatch(createOrganizationClassification(value))
        .then(res => {
          dispatch(
            fetchOrganizationClassifications(
              organizationClassificationUIProps.queryParams
            )
          );
          toast.success(res.data.message, toastOption);
          setOpenModal(prev => ({
            ...prev,
            organizationClassification: false
          }));
          setCurrentItem({});
        })
        .catch(err => {
          toast.error(err.message);
        });
    } else {
      dispatch(updateOrganizationClassification(value))
        .then(res => {
          dispatch(
            fetchOrganizationClassifications(
              organizationClassificationUIProps.queryParams
            )
          );
          toast.success(res.data.message, toastOption);
          setOpenModal(prev => ({
            ...prev,
            organizationClassification: false
          }));
          setCurrentItem({});
        })
        .catch(err => {
          toast.error(err.message);
        });
    }
  };

  const allowCreate = RoleChecker("Create", "master_data_classification");
  const allowEdit = RoleChecker("Edit", "master_data_classification");

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* CREATE FOLDER MODAL */}
      <OrganizationClassificationCreate
        show={openModal.organizationClassification}
        onHide={() => {
          setOpenModal(prev => ({
            ...prev,
            organizationClassification: false
          }));
          setCurrentItem(initialValue);
        }}
        onSubmit={onSubmitOrganizationClassification}
        defaultValues={currentItem}
      />
      <Card>
        <CardHeader title="Klasifikasi">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
            {allowCreate && (
              <button
                type="button"
                className="btn mx-1 btn-primary"
                onClick={() =>
                  setOpenModal(prev => ({
                    ...prev,
                    organizationClassification: true
                  }))
                }
              >
                Tambah Klasifikasi
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div className="collapse-filter">
              <OrganizationClassificationFilter />
            </div>
          </Collapse>
          <OrganizationClassificationTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={organizationClassificationUIProps.queryParams}
            setQueryParams={organizationClassificationUIProps.setQueryParams}
            openEditOrganizationClassificationPage={
              organizationClassificationUIProps.openEditOrganizationClassificationPage
            }
            setCurrentItem={setCurrentItem}
            setOpenModal={setOpenModal}
            allowEdit={allowEdit}
          />
        </CardBody>
      </Card>
    </>
  );
};
